var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoomSceneryCouch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 215,
    height: 101,
    viewBox: "0 0 215 101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D7D7D7",
    d: "M32 0h68a8 8 0 018 8v47H24V8a8 8 0 018-8z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F4F4F4",
    d: "M24.5 54.5h83V8A7.5 7.5 0 00100 .5H32A7.5 7.5 0 0024.5 8v46.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7D7D7",
    d: "M115 0h68a8 8 0 018 8v47h-84V8a8 8 0 018-8z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F4F4F4",
    d: "M107.5 54.5h83V8A7.5 7.5 0 00183 .5h-68a7.5 7.5 0 00-7.5 7.5v46.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7D7D7",
    d: "M193.99 82.898c-2.286.066-4.791.102-7.419.102H21.43c-.424 0-.844 0-1.26-.003A5.091 5.091 0 0120 83H5a5 5 0 01-5-5V33a5 5 0 015-5h15a5 5 0 015 5v38h161.571c1.17 0 2.316.007 3.429.021V33a5 5 0 015-5h15a5 5 0 015 5v45a5 5 0 01-5 5h-15c-.346 0-.684-.035-1.01-.102z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F4F4F4",
    d: "M193.976 82.398l.114.01c.297.061.602.092.91.092h15a4.5 4.5 0 004.5-4.5V33a4.5 4.5 0 00-4.5-4.5h-15a4.5 4.5 0 00-4.5 4.5v38.527l-.506-.006a276.61 276.61 0 00-3.423-.021H24.5V33a4.5 4.5 0 00-4.5-4.5H5A4.5 4.5 0 00.5 33v45A4.5 4.5 0 005 82.5h15c.05 0 .102 0 .171-.003.417.002.837.003 1.258.003H186.57c2.574 0 5.078-.035 7.405-.102z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7D7D7",
    d: "M7 82h15l-7.968 19H7z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F4F4F4",
    d: "M7.5 82.5v18h6.2l7.548-18H7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7D7D7",
    d: "M208 82h-15l7.968 19H208z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F4F4F4",
    d: "M207.5 82.5v18h-6.2l-7.548-18H207.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7D7D7",
    d: "M32 48h68a8 8 0 018 8v16H24V56a8 8 0 018-8z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F4F4F4",
    d: "M24.5 71.5h83V56a7.5 7.5 0 00-7.5-7.5H32a7.5 7.5 0 00-7.5 7.5v15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7D7D7",
    d: "M115 48h68a8 8 0 018 8v16h-84V56a8 8 0 018-8z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F4F4F4",
    d: "M107.5 71.5h83V56a7.5 7.5 0 00-7.5-7.5h-68a7.5 7.5 0 00-7.5 7.5v15.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomSceneryCouch);
export default __webpack_public_path__ + "static/media/RoomSceneryCouch.b401905df88cbb9ad27c642ed25a4fc9.svg";
export { ForwardRef as ReactComponent };